import React from 'react';

import { DndContext } from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { List } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import SortableItem from './SortableItem';

const SortableList = ({
    columnsConfig,
    columns,
    handleOnSelectItem,
    onDragEnd,
}) => {
    const itemsIds = columns.map((item) => item.name);
    return (
        <DndContext onDragEnd={onDragEnd}>
            <SortableContext
                items={itemsIds}
                strategy={verticalListSortingStrategy}
            >
                <List>
                    {columns.map((item, index) => (
                        <SortableItem
                            columnsConfig={columnsConfig}
                            handleOnSelectItem={handleOnSelectItem}
                            index={index}
                            item={item}
                            key={`item-${item.name}`}
                        />
                    ))}
                </List>
            </SortableContext>
        </DndContext>
    );
};

SortableList.propTypes = {
    columnsConfig: PropTypes.object,
    columns: PropTypes.array,
    handleOnSelectItem: PropTypes.func,
    onDragEnd: PropTypes.func,
};

export default SortableList;
